import React from "react";
import get from "lodash/get";
import { object, number, array } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./card-image-type-1.m.css";

const CardImageType1 = ({ story, headlineLimit, widths = [250, 480, 764] }) => {
  const slug = story["hero-image-s3-key"];
  const storyImageSlug = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${story.slug}`}>
      <div styleName="wrapper" className="card-image-type-1">
        {storyImageSlug ? (
          <CardImage story={story} defaultWidth={36} aspectRatio={[16, 9]} imageType="image16x9" widths={widths} />
        ) : (
          <PlaceholderImage className="qt-image-dynamic" story={story} />
        )}
        <Headline story={story} headerType={2} headerLevel={2} headlineLimit={headlineLimit} />
      </div>
    </Link>
  );
};

export default CardImageType1;

CardImageType1.propTypes = {
  story: object,
  headlineLimit: number,
  widths: array
};
